import * as wasm from 'sched';
import { useDatabaseEntity } from './useDatabaseEntity';

export interface ProjectDetails {
  id: string;
  name: string;
  remoteReference?: wasm.RemoteReference;
}

export function useProject(projectId: string | undefined) {
  const { entity, loading, error } = useDatabaseEntity<ProjectDetails>(projectId, {
    entityType: 'Project',
    build: async (database, id) => {
      const obj = database.projects()[id];
      if (!obj) return null;
      const base: ProjectDetails = { id, name: obj.name() };
      try {
        const remoteReference = await obj.remote_reference();
        return { ...base, remoteReference };
      } catch (err) {
        console.error('Error fetching project remote reference:', err);
        return base;
      }
    },
  });
  return { project: entity, loading, error };
}
